<template>
  <Modal
    v-model="_value"
    width="550"
    title="配置定位设备配件"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
    <div style="position:relative;">
      <Table border highlight-row size="small" height="200" :columns="columns" :stripe="true" :data="content" ref="table"
             @on-sort-change="sortChange"></Table>
      <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
        <Spin size="large"></Spin>
        <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
      </div>
    </div>
    <Row type="flex" justify="end">
      <Button type="primary" style="margin-right: 5px;" @click="addPositioningDeviceFittingsModal=true">添加设备配件</Button>
    </Row>
    <add-positioning-device-fittings-modal v-model="addPositioningDeviceFittingsModal"  :initValue="addPositioningDeviceFittingsModalId" :terminalNumValue="addPositioningDeviceFittingsModalterminalNum" @on-positioningdevicefittings="updateTable"></add-positioning-device-fittings-modal>
    <positioning-device-fittings-detail-modal v-model="positioningDeviceFittingsDetailModal" :initValue="positioningDeviceFittingDetailId"></positioning-device-fittings-detail-modal>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
import AddPositioningDeviceFittingsModal from '@/views/im/components/add-positioning-device-fittings-modal'
import PositioningDeviceFittingsDetailModal from '@/views/im/components/positioning-device-fittings-detail-modal'

export default {
  name: 'bindpositioningdevicesfittingsmodal',
  components: {
    AddPositioningDeviceFittingsModal,
    PositioningDeviceFittingsDetailModal
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {

      // 添加定位设备配件
      addPositioningDeviceFittingsModal: false,
      addPositioningDeviceFittingsModalId: null,
      addPositioningDeviceFittingsModalterminalNum: null,

      // 定位设备配件详细信息
      positioningDeviceFittingsDetailModal: false,
      positioningDeviceFittingDetailId: null,

      modify: false,
      positioningDeviceInfoStateOptions: [
        { label: '未安装', value: 1 },
        { label: '已安装', value: 2 },
        { label: '损坏', value: 3 }
      ],
      positioningDeviceModelOptions: [
        // { label: 'BSJ-A6-BD', value: 1 },
        // { label: 'BSJ-GF03', value: 2 },
        // { label: 'BSJ-M11', value: 3 },
        // { label: 'BSJ-A6L', value: 13 },
        // { label: 'BSJ-A7', value: 14 },
        // { label: 'K5', value: 4 },
        // { label: 'D5X', value: 5 },
        // { label: 'G-3G', value: 6 },
        // { label: 'D5X-HDD', value: 7 },
        // { label: 'D5X-XR', value: 8 },
        // { label: 'BSJ-GF06', value: 9 },
        // { label: 'BSJ-RM01', value: 10 },
        // { label: 'HIK-A3', value: 11 },
        // { label: 'HIK-A3L', value: 12 }
      ],
      positioningDeviceSourceTypeOptions: [
        { label: '新装', value: 1 },
        { label: '接入', value: 2 }
      ],
      positioningDeviceInfo: {
        id: null,
        terminalNum: null,
        factoryTerminalNum: null,
        positioningDeviceModel: null,
        positioningDeviceModelId: null,
        sourceType: null,
        remark: null,
        setupDatetime: null,
        serviceDatetime: null
      },
      listLoadding: false,
      columns: [
        {
          title: 'ID',
          key: 'id',
          sortable: 'custom',
          tooltip: 'true',
          minWidth: 70
        },
        {
          title: '主机号',
          key: 'terminalNum',
          ellipsis: 'true',
          minWidth: 100
        },
        {
          title: '设备型号',
          key: 'positioningDeviceModelId',
          ellipsis: 'true',
          minWidth: 100,
          render: function (h, params) {
            if (params.row.positioningDeviceModel) {
              let positioningDeviceModel = params.row.positioningDeviceModel
              return h('div', positioningDeviceModel.name)
            }else {
              return h('div', '未知')
            }
            // let positioningDeviceModel = params.row.positioningDeviceModelId
            // if (positioningDeviceModel === 1) {
            //   return h('div', 'BSJ-A6-BD')
            // } else if (positioningDeviceModel === 2) {
            //   return h('div', 'BSJ-GF03')
            // } else if (positioningDeviceModel === 3) {
            //   return h('div', 'BSJ-M11')
            // } else if (positioningDeviceModel === 13) {
            //   return h('div', 'BSJ-A6L')
            // } else if (positioningDeviceModel === 14) {
            //   return h('div', 'BSJ-A7')
            // } else if (positioningDeviceModel === 4) {
            //   return h('div', 'K5')
            // } else if (positioningDeviceModel === 5) {
            //   return h('div', 'D5X')
            // } else if (positioningDeviceModel === 6) {
            //   return h('div', 'G-3G')
            // } else if (positioningDeviceModel === 7) {
            //   return h('div', 'D5X-HDD')
            // } else if (positioningDeviceModel === 8) {
            //   return h('div', 'D5X-XR')
            // } else if (positioningDeviceModel === 9) {
            //   return h('div', 'BSJ-GF06')
            // } else if (positioningDeviceModel === 10) {
            //   return h('div', 'BSJ-RM01')
            // } else if (positioningDeviceModel === 11) {
            //   return h('div', 'HIK-A3')
            // } else if (positioningDeviceModel === 12) {
            //   return h('div', 'HIK-A3L')
            // } else {
            //   return h('div', '未知')
            // }
          }
        },
        {
          title: '操作',
          key: 'action',
          align: 'left',
          ellipsis: 'true',
          minWidth: 150,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'primary',
                  size: 'small',
                  disabled: false
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.positioningDeviceFittingDetailId = params.row.id
                    this.positioningDeviceFittingsDetailModal = true
                  }
                }
              }, '详细信息')
              // h('Button', {
              //   props: {
              //     type: 'primary',
              //     size: 'small',
              //     disabled: false
              //   },
              //   style: {
              //     marginRight: '5px'
              //   },
              //   on: {
              //     click: () => {
              //       this.$Modal.confirm({
              //         title: '确认删除',
              //         content: '<p>确认删除</p>',
              //         onOk: () => {
              //           store.dispatch('PositioningDeviceFittingsServ_DeleteObj', {
              //             params: { id: params.row.id }
              //           }).then(() => {
              //             this.$Message.success('删除成功')
              //             this.updateTable()
              //             this.$emit('on-success')
              //           }).catch(err => {
              //             this.$Message.error(err)
              //             this.$emit('on-fail')
              //           })
              //         },
              //         onCancel: () => {
              //
              //         }
              //       })
              //     }
              //   }
              // }, '删除')
            ])
          }
        }
      ]
    }
  },
  methods: {
    ...mapActions([
      'PositioningDeviceInfoServ_GetDetail',
      'PositioningDeviceInfoServ_ModifyObj',
      'InstallOrderServ_BindPositioningDeviceInfos',
      'InstallOrderServ_UnBindPositioningDeviceInfos',
      'PositioningDeviceInfoServ_GetAll'
    ]),
    sortChange ({ column, key, order }) {
      this.sort = {
        name: key,
        asc: order === 'asc'
      }
      this.refreshPage()
    },
    updateTable () {
      this.listLoadding = true
      let queryParams = []
      let sortParam = null
      queryParams.push(genQueryParam('installOrderId', 'EQ', this._initValue))
      store.dispatch('PositioningDeviceFittingsServ_GetAll', {
        params: null,
        urlparams: {
          q: queryParams,
          keyword: null,
          sort: sortParam
        }
      }).then(() => {
        this.listLoadding = false
      }).catch(err => {
        this.listLoadding = false
        this.$Message.error(err)
      })
    },
    visibleChange (val) {
      if (val) {
        let installOrderId = this._initValue
        this.addPositioningDeviceFittingsModalId = this._initValue
        if (installOrderId) {
          this.listLoadding = true
          let queryParams = []
          let sortParam = null
          queryParams.push(genQueryParam('installOrderId', 'EQ', installOrderId))
          store.dispatch('PositioningDeviceFittingsServ_GetAll', {
            params: null,
            urlparams: {
              q: queryParams,
              keyword: null,
              sort: sortParam
            }
          }).then(() => {
            this.listLoadding = false
          }).catch(err => {
            this.listLoadding = false
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    content () {
      if (store.getters.get_PositioningDeviceFittings_GetAllResult) {
        return store.getters.get_PositioningDeviceFittings_GetAllResult
      } else {
        return []
      }
    },
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {
      // store.dispatch('PositioningDeviceTypeServ_GetAll',{
      //   params:null,
      //   urlparams:null
      // }).then(()=>{
      //
      //   if (store.getters.get_PositioningDeviceType_GetAllResult) {
      //     store.getters.get_PositioningDeviceType_GetAllResult.forEach(item=>{
      //       this.PositioningDeviceModellist.push({name: item.name, val: item.id},)
      //     })
      //   }
      // }).catch(err=>{
      //   console.log(err)
      // })
    })
  }
}
</script>
